import React from "react";
import { EmailInput } from "../../components/inputs/email-input";
import { Button } from "../../components/buttons/button";
import { z } from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form, FormControl, FormField, FormItem } from "../../components/base/form";
interface ForgottenPasswordProps {
  onSubmit(email: string): Promise<void>;
  loading: boolean;
}

const UserSchema = z.object({
  email: z
    .string({ required_error: "Please enter an email address" })
    .email({ message: "Please enter a valid email address" }),
});

export type FormFields = z.infer<typeof UserSchema>;

export const RequestPasswordResetForm: React.FC<ForgottenPasswordProps> = (props) => {
  const form = useForm<FormFields>({
    mode: "onTouched",
    resolver: zodResolver(UserSchema),
    reValidateMode: "onChange",
  });

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    void props.onSubmit(form.getValues("email"));
  };

  return (
    <Form {...form}>
      <form className="flex flex-col gap-4.5 md:gap-6" onSubmit={(event) => handleSubmit(event)}>
        <div className="flex flex-col gap-4 md:gap-5">
          <FormField
            control={form.control}
            name={"email"}
            render={() => (
              <FormItem>
                <FormControl>
                  <Controller
                    name={"email"}
                    control={form.control}
                    render={({ field: { onBlur, value, onChange } }) => (
                      <EmailInput
                        state={form.formState.errors.email ? "error" : "default"}
                        id="user-email"
                        placeholder="Enter your email address..."
                        label="Email address"
                        labelSize="large"
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        message={form.formState.errors.email?.message}
                      />
                    )}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        <Button
          label="Continue"
          colorVariant="primary"
          loading={props.loading}
          loadingLabel="Sending email..."
          variant="solid"
          disabled={props.loading || !form.getValues("email") || !form.formState.isValid}
          type="submit"
        />
      </form>
    </Form>
  );
};
